import { render, staticRenderFns } from "./CardIntervals.vue?vue&type=template&id=0ad869c6"
import script from "./CardIntervals.vue?vue&type=script&lang=ts"
export * from "./CardIntervals.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports